import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetDripSequenceStartTrigger as SetDripSequenceStartTriggerMutation,
    SetDripSequenceStartTriggerVariables as SetDripSequenceStartTriggerVariables,
    StartTriggerSetInput,
} from 'nutshell-graphql-types';

import SET_DRIP_SEQUENCE_START_TRIGGER from '../mutations/set-drip-sequence-start-trigger.graphql';

export const useSetDripSequenceStartTrigger = (): {
    setDripSequenceStartTrigger: (input: StartTriggerSetInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setDripSequenceStartTrigger, {loading, error}] = useMutation<
        SetDripSequenceStartTriggerMutation,
        SetDripSequenceStartTriggerVariables
    >(SET_DRIP_SEQUENCE_START_TRIGGER);

    return {
        setDripSequenceStartTrigger: (input: StartTriggerSetInput) =>
            setDripSequenceStartTrigger({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
